export { UserSharedModule } from './user-shared.module';



// WEBPACK FOOTER //
// /dist/src/app/user/user-shared/index.ts